import { Badge, Box, Dialog, Grid, IconButton, Tooltip, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import TableContainer from '../../../Components/TableContainer/TableContainer'
import { useDispatch, useSelector } from 'react-redux'
import Constant from '../../../Utils/Constant'
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import CheckIcon from "@mui/icons-material/Check";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import CloseIcon from "@mui/icons-material/Close";
import { toast } from 'react-toastify'
import { useNavigate } from 'react-router-dom'
import Swal from 'sweetalert2'
import { GET_USERS_INTERPRETOR, USER_INTERPRETER_LANGUAGE_COMMISION_FIRST_ACTION, USER_INTERPRETO_ACCOUNT_APPROVE_FIRST } from '../../../Redux/Slices/UserSlice/User.action'
import CustomLineChart from '../../../Components/CustomLineChart/CustomLineChart'
import { useFormik } from 'formik'
import CustomSubmitButton from '../../../Components/CustomSubmitButton/CustomSubmitButton'
import { GET_DASHBOARD_ANALYTICS_ACTION } from '../../../Redux/Slices/DashboardSlice/Dashboard.action';
import NotificationsIcon from '@mui/icons-material/Notifications';
import { ADD_UPDATE_NOTIFICATION_FCM_ACTION, GET_NOTIFICATION_UNREAD_COUNT_ACTION } from '../../../Redux/Slices/NotificationSlice/NotificationSlice.action'
import Skeleton from 'react-loading-skeleton';
import { messaging } from "../../../Config/Firebase";
import { getToken } from "firebase/messaging";
import CustomRejectInterpreter from '../../../Components/CustomRejectInterpreter/CustomRejectInterpreter'
import AxiosInstance from '../../../Config/AxiosInstance'
import APILIST from '../../../Config/ApiList'
const Dashboard = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const checkUser = localStorage.getItem("Interpreto");
  const checkUserId = JSON.parse(checkUser)?.id
  const [skip, setSkip] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [limit, setLimit] = useState(50);
  const [interpreterList, setInterpreterList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [showLanguagePercentageModel, setShowLanguagePercentageModel] = useState(false);
  const [userLanguageList, setUserLanguageList] = useState([]);
  const [status, setStatus] = useState(null);
  const [userId, setUserId] = useState(null);
  const [showRejectModel, setShowRejectModel] = useState(false);
  const { newNotification_unread_count, analytics } = useSelector((state) => ({
    newNotification_unread_count: state?.ALL_NOTIFICATIONS?.newNotification_unread_count,
    analytics: state?.DASHBOARD_ANALAYTICS?.analytics
  }))

  const columns = [
    {
      field: "rowid",
      headerName: "Sr.No.",
      minWidth: 100,
      filterable: false,
      editable: false,
      sortable: false,
      disableColumnMenu: true,
    },
    {
      hideOnMobile: true,
      field: "profile_img",
      headerName: "Profile",
      minWidth: 50,
      filterable: false,
      editable: false,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return params?.row?.profile_img ? (
          <img
            src={`${Constant.BASE_URL}${params?.row?.profile_img}`}
            alt="profile_photo"
            style={{
              width: "40px",
              height: "40px",
              borderRadius: "10px",
            }}
          />
        ) : (
          <AccountCircleIcon sx={{ fontSize: "40px" }} />
        );
      },
    },
    {
      field: "full_name",
      headerName: "Full Name",
      minWidth: 250,
      filterable: true,
      sortable: true,
      renderCell: (params) => {
        const fullName = params?.row?.full_name || "--";
        return (
          <Tooltip title={fullName?.length > 25 ? fullName : ""}>
            <span>
              {fullName?.length > 25
                ? `${fullName?.substring(0, 25)}...`
                : fullName}
            </span>
          </Tooltip>
        );
      },
    },
    {
      field: "email",
      headerName: "Email",
      flex: 1,
      minWidth: 300,
      hideOnMobile: true,
      renderCell: (params) => (
        <Tooltip title={params?.row?.email || "--"}>
          <span>{params?.row?.email || "--"}</span>
        </Tooltip>
      ),
    },
    {
      field: "phone",
      headerName: "Phone Number",
      minWidth: 200,
      filterable: false,
      editable: false,
      sortable: false,
      hideOnMobile: true,
      disableColumnMenu: true,
      renderCell: (params) => (
        <span>
          {params?.row?.phno_cc && params?.row?.phno
            ? `${params?.row?.phno_cc} ${params?.row?.phno}`
            : "--"}
        </span>
      ),
    },
    {
      field: "action",
      headerName: "Actions",
      minWidth: 140,
      filterable: false,
      editable: false,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        const { interpreter_verified, id } = params?.row;
        const actionButtons = [];
        if (interpreter_verified === 0) {
          actionButtons.push(
            <>
              <Tooltip title="Approve Request">
                <IconButton
                  sx={{
                    background: "#4caf50",
                    width: "30px",
                    height: "30px",
                    borderRadius: "4px",
                    "&:hover": { background: "#388e3c" },
                  }}
                  onClick={() => handleInterPreterAccountStatusChange(id, 1, params)}
                >
                  <CheckIcon sx={{ color: "#fff" }} />
                </IconButton>
              </Tooltip>
              <Tooltip title="Reject Request">
                <IconButton
                  sx={{
                    background: "red",
                    "&:hover": { background: "#c62828" },
                    width: "30px",
                    height: "30px",
                    borderRadius: "4px",
                  }}
                  onClick={() => handleInterPreterAccountRejectModel(id, -1)}
                >
                  <CloseIcon sx={{ color: "#fff" }} />
                </IconButton>
              </Tooltip>
            </>
          );
        }
        actionButtons.push(
          <Tooltip title="View" key="view">
            <IconButton
              onClick={() => {
                if (params?.row?.is_interpreter === 0) {
                  navigate(`/admin/user-details`, {
                    state: { id: id },
                  });
                } else {
                  navigate(`/admin/interpreter-details`, {
                    state: { id: id },
                  });
                }
              }
              }
              sx={{
                width: "30px",
                height: "30px",
                borderRadius: "4px",
                background:
                  "linear-gradient(148.97deg, #0C2C50 0%, #450F5B 100%)",
                "&:hover": {
                  background:
                    "linear-gradient(148.97deg, #0C2C50 0%, #450F5B 100%)",
                },
              }}
            >
              <RemoveRedEyeIcon sx={{ color: "#fff" }} />
            </IconButton>
          </Tooltip>)
        return (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "10px",
            }}
          >
            {actionButtons}
          </Box>
        );
      },
    },
  ];
  useEffect(() => {
    getInterpreterList();
    dispatch(GET_DASHBOARD_ANALYTICS_ACTION())
    dispatch(GET_NOTIFICATION_UNREAD_COUNT_ACTION(checkUserId))
  }, [dispatch]);
  const getInterpreterList = async () => {
    setIsLoading(true)
    await dispatch(GET_USERS_INTERPRETOR({ skip, limit })).unwrap()
      .then((res) => {
        if (res && res?.s === 1) {
          const Rowdata = res?.r?.filter((elem) => elem?.is_interpreter === 1)?.map((data, i) => ({
            rowid: i + 1 + skip * limit,
            ...data,
          }));
          setIsLoading(false)
          setInterpreterList(Rowdata?.slice(0, 5));
          setTotalCount(res?.total || 0);
        } else {
          setInterpreterList([]);
          setIsLoading(false)
        }
      }).catch((error) => {
        console.log('error', error);
        setIsLoading(false)
      })
  }
  const handlePageSizeChange = (newPageSize) => {
    setLimit(newPageSize);
    setSkip(0);
  };
  const handlePageChange = (newPage) => {
    setSkip(newPage);
  };
  const handleInterPreterAccountStatusChange = async (userId, status, params) => {
    Swal.fire({
      title: 'Are you sure?',
      text: status === 1 ? 'Do you want to accept this request?' : "Do you want to reject this request",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      reverseButtons: true,
    }).then(async (result) => {
      if (result.isConfirmed) {
        if (params?.row?.user_languages?.length > 0 && status === 1) {
          const data = params?.row?.user_languages.map((language, index) => ({
            id: language?.id,
            commission: params?.row?.is_premium === 1 ? 20 : 30
          }));
          const formData = new FormData();
          formData.append("commission", JSON.stringify(data));

          const resCommision = await dispatch(USER_INTERPRETER_LANGUAGE_COMMISION_FIRST_ACTION(formData)).unwrap();

          if (resCommision && resCommision?.s === 1) {
            const userLanguageList = params?.row?.user_languages
            const approvalRes = await dispatch(USER_INTERPRETO_ACCOUNT_APPROVE_FIRST({ userId, status, userLanguageList })).unwrap();
            for (const language of userLanguageList) {
              const certificates = language?.certificates || [];
              for (const cert of certificates) {
                const formDataCert = new FormData();
                formDataCert.append("certificate_id", cert.id);
                formDataCert.append("status", status);
                await AxiosInstance.post(`${APILIST.ADD_UPDATE_CERTIFICATE_REQUEST}/${cert.id}`, formDataCert);
              }
            }
            if (approvalRes && approvalRes?.s === 1) {
              toast.success("Request Approved Successfully!");
              getInterpreterList();
              setIsLoading(false);
            } else {
              toast.error(approvalRes?.m);
              setIsLoading(false);
            }
          }
        } else {
          toast.error("Cannot approve interpreter without any languages");
        }
      }
    });
  };
  const handleInterPreterAccountRejectModel = (userId) => {
    if (userId) {
      setShowRejectModel(true);
      setUserId(userId);
    }
  }
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      percentages: userLanguageList?.reduce((acc, elem) => {
        acc[elem?.language] = '';
        return acc;
      }, {})
    },
    validate: (values) => {
      const errors = { percentages: {} };
      Object.entries(values.percentages).forEach(([lang, value]) => {
        const numValue = Number(value);
        if (value === '') {
          errors.percentages[lang] = 'Required';
        } else if (isNaN(numValue) || numValue < 0) {
          errors.percentages[lang] = 'Must be a valid positive number';
        } else if (numValue > 100) {
          errors.percentages[lang] = 'Cannot exceed 100%';
        }
      });

      return Object.keys(errors.percentages).length ? errors : {};
    },
    onSubmit: async (values, { resetForm }) => {
      setIsLoading(true);
      try {
        const formData = new FormData();
        formData.append("user_id", userId)
        const data = userLanguageList.map((language, index) => ({
          id: language?.id,
          commission: values?.percentages[language?.language] || 0
        }));
        formData.append("commission", JSON.stringify(data));
        const res = await dispatch(USER_INTERPRETER_LANGUAGE_COMMISION_FIRST_ACTION(formData)).unwrap();
        if (res && res?.s === 1) {
          const approvalRes = await dispatch(USER_INTERPRETO_ACCOUNT_APPROVE_FIRST({ userId, status })).unwrap();
          if (approvalRes && approvalRes?.s === 1) {
            toast.success("Request Approved Successfully!");
            getInterpreterList();
            setShowLanguagePercentageModel(false);
            resetForm();
            setIsLoading(false);
          } else {
            toast.error(approvalRes?.m);
            setIsLoading(false);
          }
        }
      } catch (error) {
        console.error('Error:', error);
        toast.error("Something went wrong. Please try again.");
        setIsLoading(false);
      }
    }
  });
  const handleSubmitAcceptReject = () => {
    getInterpreterList();
    setShowRejectModel(false);
    setStatus(null);
    setUserId(null);
  }
  const requestPermission = async () => {
    const permission = await Notification.requestPermission();
    if (permission === "granted") {
      const token = await getToken(messaging, {
        vapidKey:
          "BHkfraONOxT4EtMlFZDNf7EJ1QBA09H5VDX4aY60_oY2t2Ovw8Wt4HiaiMpDL0jGdKfQ4WrVjnWQDZfEopGj3KM",
      });
      const deviceId = localStorage.getItem("deviceId");
      const formData = new FormData();
      const userId = localStorage.getItem("Interpreto");
      formData.append("user_id", JSON.parse(userId)?.id);
      formData.append("fcm_token", token);
      formData.append("device_id", deviceId);
      await dispatch(ADD_UPDATE_NOTIFICATION_FCM_ACTION(formData));
    } else if (permission === "denied") {
      console.log('You denied for the notification');
    }
  }
  React.useEffect(() => {
    requestPermission();
  }, []);
  return (
    <>
      <Box sx={{
        width: '100%',
        padding: '10px 15px'
      }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Box sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              gap: '10px',
            }}>
              <Typography sx={{ fontSize: "24px", fontWeight: "500", fontFamily: 'Outfit', }}>
                Dashboard
              </Typography>
              <Badge badgeContent={newNotification_unread_count} color="primary" sx={{ cursor: "pointer" }} onClick={() => navigate("/admin/manage-new-language")} id="new-notification-menu">
                <NotificationsIcon color="action" sx={{
                  fontSize: "30px",
                  cursor: "pointer",
                  color: "rgba(0, 151, 178, 1)",
                  "&:hover": { color: "rgba(0, 151, 178, 1)" },
                }} />
              </Badge>
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} md={2}>
            <Box sx={{
              background: "rgba(148, 148, 148, 0.1)",
              padding: '25px 20px',
              borderRadius: '15px',
            }}>
              <Typography sx={{
                color: 'rgba(8, 85, 127, 1)',
                fontSize: '18px',
                fontWeight: '600',
                fontFamily: 'Outfit',
                textAlign: 'left'
              }}>{isLoading ? <Skeleton width={40} height={20} /> : analytics?.total_users}</Typography>
              <Typography sx={{
                fontSize: "16px",
                fontWeight: "300",
                color: "rgba(0, 0, 0, 0.7)",
                fontFamily: 'Outfit',
                textAlign: 'left'
              }}>Total User</Typography>
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Box sx={{
              background: "rgba(148, 148, 148, 0.1)",
              padding: '25px 20px',
              borderRadius: '15px',
            }}>
              <Typography sx={{
                color: 'rgba(8, 85, 127, 1)',
                fontSize: '18px',
                fontWeight: '600',
                fontFamily: 'Outfit',
                textAlign: 'left'
              }}>{isLoading ? <Skeleton width={40} height={20} /> : analytics?.total_interpreters}</Typography>
              <Typography sx={{
                fontSize: "16px",
                fontWeight: "300",
                color: "rgba(0, 0, 0, 0.7)",
                fontFamily: 'Outfit',
                textAlign: 'left'
              }}>Total Interpreter</Typography>
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <Box sx={{
              background: "rgba(148, 148, 148, 0.1)",
              padding: '25px 20px',
              borderRadius: '15px',
            }}>
              <Typography sx={{
                color: 'rgba(8, 85, 127, 1)',
                fontSize: '18px',
                fontWeight: '600',
                fontFamily: 'Outfit',
                textAlign: 'left'
              }}>{isLoading ? <Skeleton width={40} height={20} /> : analytics?.premium_interpreters}</Typography>
              <Typography sx={{
                fontSize: "16px",
                fontWeight: "300",
                color: "rgba(0, 0, 0, 0.7)",
                fontFamily: 'Outfit',
                textAlign: 'left'
              }}>Premium Interpreter</Typography>
            </Box>
          </Grid>
          {/* <Grid item xs={12} sm={6} md={2}>
            <Box sx={{
              background: "rgba(148, 148, 148, 0.1)",
              padding: '25px 20px',
              borderRadius: '15px',
            }}>
              <Typography sx={{
                color: 'rgba(8, 85, 127, 1)',
                fontSize: '18px',
                fontWeight: '600',
                fontFamily: 'Outfit',
                textAlign: 'left'
              }}>{isLoading ? <Skeleton width={40} height={20} /> : "N/A"}</Typography>
              <Typography sx={{
                fontSize: "16px",
                fontWeight: "300",
                color: "rgba(0, 0, 0, 0.7)",
                fontFamily: 'Outfit',
                textAlign: 'left'
              }}>Both Account</Typography>
            </Box>
          </Grid> */}
          <Grid item xs={12} sm={6} md={2}>
            <Box sx={{
              background: "rgba(148, 148, 148, 0.1)",
              padding: '25px 20px',
              borderRadius: '15px',
            }}>
              <Typography sx={{
                color: 'rgba(8, 85, 127, 1)',
                fontSize: '18px',
                fontWeight: '600',
                fontFamily: 'Outfit',
                textAlign: 'left'
              }}>{isLoading ? <Skeleton width={40} height={20} /> : analytics?.total_session}</Typography>
              <Typography sx={{
                fontSize: "16px",
                fontWeight: "300",
                color: "rgba(0, 0, 0, 0.7)",
                fontFamily: 'Outfit',
                textAlign: 'left'
              }}>Total Session</Typography>
            </Box>
          </Grid>
          <Grid item xs={12}>
            <CustomLineChart isLoading={isLoading} />
          </Grid>
          <Grid item xs={12}>
            <Typography sx={{ fontSize: "22px", fontWeight: "500", fontFamily: 'Outfit', color: "rgba(0, 151, 178, 1)", padding: '10px 0px' }}>
              Recent Interpreter Request
            </Typography>
            <TableContainer
              rows={interpreterList}
              columns={columns}
              loading={isLoading}
              page={skip}
              pageSize={limit}
              totalCount={totalCount}
              handlePageChange={handlePageChange}
              onPageSizeChange={handlePageSizeChange}
              paginationShow={false}
            />
          </Grid>
        </Grid>
      </Box>
      {showLanguagePercentageModel &&
        <Dialog
          open={showLanguagePercentageModel}
          onClose={() => setShowLanguagePercentageModel(false)}
          maxWidth="sm"
          fullWidth
          sx={{
            "& .MuiPaper-root": {
              borderRadius: "20px",
              padding: '20px 30px',
              height: "auto",
              overflow: "scroll",
              "::-webkit-scrollbar": { width: "0px", height: '0px' },
              display: "flex",
              flexDirection: "column",
              zIndex: 9999
            },
            "& .MuiDialogContent-root": {
              overflowY: "initial",
              flexGrow: 1,
            },
            "& .MuiBackdrop-root": {
              backgroundColor: 'rgba(0, 0, 0, 0.8)',
            }
          }}
        >
          <form onSubmit={(e) => {
            e.preventDefault();
            formik.handleSubmit();
            return false;
          }}>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Typography sx={{ fontSize: '20px', fontWeight: '500', color: '#101010', fontFamily: "Outfit" }}>
                  Enter Language Percentage
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                  <IconButton
                    sx={{
                      width: '30px',
                      height: '30px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      backgroundColor: '#101010',
                      borderRadius: '8px',
                      "&:hover": { backgroundColor: '#101010', color: '#fff' }
                    }}
                    onClick={() => setShowLanguagePercentageModel(false)}
                  >
                    <CloseIcon sx={{ color: '#fff', fontSize: '20px' }} />
                  </IconButton>
                </Box>
              </Grid>
            </Grid>

            <Box sx={{ padding: '20px 0px 0px 0px', flexGrow: 1 }}>
              <Grid container spacing={2} justifyContent={'space-between'}>
                {userLanguageList?.length > 0 && userLanguageList?.map((elem, index) => {
                  return (
                    <Grid item xs={12} key={index}>
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={7}>
                          <Typography sx={{ color: "rgba(0, 0, 0, 0.6)", fontWeight: "400", textAlign: "left", fontSize: { xs: "16px", sm: "18px" }, fontFamily: "Outfit", paddingBottom: '10px' }}>
                            Language & Rate
                          </Typography>
                          <Box sx={{ background: "rgba(250, 250, 250, 1)", border: "1px solid rgba(8, 85, 127, 0.2)", padding: "15px 10px", borderRadius: '15px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <Typography sx={{ color: "rgba(8, 85, 127, 1)", fontWeight: "400", textAlign: "left", fontSize: { xs: "16px", sm: "18px" }, fontFamily: "Outfit" }}>
                              {elem?.language}
                            </Typography>
                            <Typography sx={{ color: "rgba(0, 0, 0, 1)", fontWeight: "400", textAlign: "left", fontSize: { xs: "16px", sm: "18px" }, fontFamily: "Outfit" }}>
                              Hourly Rate : {elem?.hourly_rate}$
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid item xs={12} md={5}>
                          <Typography sx={{ color: "rgba(0, 0, 0, 0.6)", fontWeight: "400", textAlign: "left", fontSize: { xs: "16px", sm: "18px" }, fontFamily: "Outfit", paddingBottom: '10px' }}>
                            Enter Percentage
                          </Typography>
                          <input
                            placeholder='0%'
                            type='number'
                            name={`percentages.${elem.language}`}
                            value={formik.values.percentages[elem.language] || ''}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            style={{
                              background: "rgba(64, 196, 255, 0.1)",
                              border: "1px solid rgba(64, 196, 255, 1)",
                              padding: '17px 10px',
                              borderRadius: '15px',
                              width: '100%',
                              fontSize: '16px',
                              fontFamily: 'Outfit',
                              fontWeight: '400',
                              color: '#000',
                              outline: 'none',
                            }}
                          />
                          {formik.touched.percentages?.[elem.language] &&
                            formik.errors.percentages?.[elem.language] && (
                              <Typography sx={{ color: 'red', fontSize: '14px' }}>
                                {formik.errors.percentages[elem.language]}
                              </Typography>
                            )}
                        </Grid>
                      </Grid>
                    </Grid>
                  )
                })}
              </Grid>
            </Box>
            <Box sx={{ paddingTop: '20px' }}>
              <CustomSubmitButton
                btnTitle="Done"
                loading={isLoading}
                type="submit"
              />
            </Box>
          </form>
        </Dialog>}
      <CustomRejectInterpreter
        open={showRejectModel}
        onClose={() => setShowRejectModel(false)}
        userId={userId}
        handleOnClose={() => setShowRejectModel(false)}
        status={-1}
        handleSubmitAcceptReject={handleSubmitAcceptReject}
      />
    </>
  )
}

export default Dashboard